import { Expose, Type } from "class-transformer";
import { DriveItemDTO } from "./item";
import { IsOptional } from "class-validator";

export class DriveLsInputDTO {
    @IsOptional()
	folderID?: string;
}

export class DriveLsOutDTO {
	@Type(() => DriveItemDTO)
	@Expose()
	item: DriveItemDTO;

	@Type(() => DriveItemDTO)
	@Expose()
	children: DriveItemDTO[]
}
